import { useApi } from "../../../swr/useApi";
import { inboxService } from "../../api_client";
import type { UnreadCountDto } from "../../../api";

const POLL_INTERVAL_MS = 30_000;

export function useUnreadInboxCount() {
  return useApi<UnreadCountDto>(
    "my-inbox-unread-count",
    () => inboxService.getMyInboxUnreadCount(),
    {
      refreshInterval: POLL_INTERVAL_MS,
      revalidateOnFocus: true,
    },
  );
}
